import { render } from "./DangerIcon.vue?vue&type=template&id=48b222c3&ts=true"
import script from "./DangerIcon.vue?vue&type=script&lang=ts"
export * from "./DangerIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__